import PostDetailsPanel from './PostDetailsPanel';
export default PostDetailsPanel;
